import React, { useState } from "react";
import "./Contact.css";

function Contact() {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
  };

  return (
    <main className="contact-page">
      <section className="contact-hero">
        <div className="contact-hero-overlay" />
        <div className="contact-container contact-hero-content">
          <span className="contact-label">Contact</span>
          <h1>
            Let&apos;s move your
            <br />
            <span>next project forward.</span>
          </h1>
          <p>
            Talk to the Strides team about energy infrastructure, maritime
            operations, project delivery or tailored technical support.
          </p>
        </div>
      </section>

      <section className="contact-main">
        <div className="contact-container contact-layout">
          <div className="contact-details">
            <span className="contact-label">Start a conversation</span>
            <h2>Built around your needs.</h2>
            <p>
              Share a few details about your requirement and our team will get
              back to you with the right point of contact.
            </p>

            <div className="contact-detail-list">
              <div>
                <span>Email</span>
                <a href="mailto:info@stridesenergy.com">info@stridesenergy.com</a>
              </div>
              <div>
                <span>Phone</span>
                <a href="tel:+2348068222439">+234 806 822 2439</a>
              </div>
              <div>
                <span>Office</span>
                <p>Port Harcourt, Rivers State, Nigeria</p>
              </div>
            </div>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <label>
              Full name
              <input type="text" name="name" required />
            </label>
            <label>
              Work email
              <input type="email" name="email" required />
            </label>
            <label>
              How can we help?
              <select name="subject" defaultValue="">
                <option value="" disabled>Select a service</option>
                <option>Energy infrastructure</option>
                <option>Maritime operations</option>
                <option>Vessels and marine support</option>
                <option>Project partnership</option>
              </select>
            </label>
            <label>
              Message
              <textarea name="message" rows="5" required />
            </label>
            <button type="submit">
              {submitted ? "Message Ready" : "Send Enquiry"}
              <span>→</span>
            </button>
            {submitted && (
              <p className="contact-success" role="status">
                Thank you. Your enquiry has been prepared for our team.
              </p>
            )}
          </form>
        </div>
      </section>
    </main>
  );
}

export default Contact;
